<template>
  <div class="p-grade">
    <header>
      <CardTitle>{{ titleName }}</CardTitle>
      <!-- <div class="tab-change">
        <p class="tab pointer">科目</p>
        <p class="tab pointer">学生</p>
      </div> -->
    </header>
    <section>
      <div class="resource-count"></div>
    </section>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import CardTitle from './card-title.vue';

export default {
  name: 'ResourceGradeUser',
  components: {
    CardTitle,
  },
  props: {
    titleName: {
      type: String,
      default: '年级分布',
    },
    userGradeList: {
      type: Array,
      default: () => [],
    },
    userGradeCount: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      subjectList: [],
    };
  },
  methods: {
    initCharts() {
      // const that = this;
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.resource-count'));
      // 绘制图表
      myChart.setOption({
        legend: {
          top: 18,
          // left: 280,
          data: ['三年级13.2%', '四年级15.4%', '五年级18.3%', '六年级21.9%', '七年级11.7%', '八年级19.5%'],
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: 'write',
            fontWeight: 'normal',
            fontSize: '14px',
          },
        },
        color: ['#1D026D', '#F756B8', '#0ECF7D', '#FFA04D', '#B040EF', '#4E85FF', '#3BE8FA', '#FFE01B', '#FF4038'],
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            startAngle: 180,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#1D026D',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 50, name: '' },
              { value: 4, name: '三年级13.2%' },
              { value: 6, name: '四年级15.4%' },
              { value: 8, name: '五年级18.3%' },
              { value: 15, name: '六年级21.9%' },
              { value: 4, name: '七年级11.7%' },
              { value: 13, name: '八年级19.5%' },
            ],
          },
        ],
      });
    },
  },
  mounted() {
    this.initCharts();
  },
};
</script>
<style lang="scss" scoped>
.p-grade {
  position: relative;
  box-sizing: border-box;
  padding: 20px;
  width: 402px;
  height: 232px;
  background: url("~@/views/pt/images/exhibition-resource-school.png") no-repeat;
  background-size: 402px 232px;
  .tab-change {
    width: 130px;
    height: 32px;
    background: rgba(255, 255, 255, 0.08);
    box-shadow: 0px 8px 8px 0px rgba(0, 61, 163, 0.22),
      0px -8px 8px 0px rgba(0, 61, 163, 0.27),
      8px 0px 8px 0px rgba(0, 61, 163, 0.22),
      -8px 0px 8px 0px rgba(0, 61, 163, 0.27);
    border-radius: 4px;
    border: 2px solid;
    border-image: linear-gradient(
        273deg,
        rgba(53, 162, 255, 0.19),
        rgba(118, 223, 255, 1),
        rgba(75, 143, 255, 0.31)
      )
      2 2;
    position: absolute;
    top: 20px;
    right: 60px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .tab {
      width: 28px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #e0efff;
      line-height: 20px;
    }
  }
  .resource-count {
    width: 360px;
    height: 180px;
    background: url("../../images/exhibition-arch.png") no-repeat center bottom;
    background-size: 200px 97px;
  }
}
</style>
